export const DoctorTypeConstants = {
    
    
    REGISTER_DOCTOR_REQUEST: 'REGISTER_DOCTOR_REQUEST',
    REGISTER_DOCTOR_SUCCESS: 'REGISTER_DOCTOR_SUCCESS',
    REGISTER_DOCTOR_FAILURE: 'REGISTER_DOCTOR_FAILURE',
    
    UPDATE_DOCTOR_REQUEST: 'UPDATE_DOCTOR_REQUEST',
    UPDATE_DOCTOR_SUCCESS: 'UPDATE_DOCTOR_SUCCESS',
    UPDATE_DOCTOR_FAILURE: 'UPDATE_DOCTOR_FAILURE',

    DOCTOR_APPOINTMENT_REQUEST : 'DOCTOR_APPOINTMENT_REQUEST' ,
    DOCTOR_APPOINTMENT_SUCCESS : 'DOCTOR_APPOINTMENT_SUCCESS' ,
    DOCTOR_APPOINTMENT_FAILIURE : 'DOCTOR_APPOINTMENT_FAILIURE',
    
    GET_ALL_DOCTOR_REQUEST : 'GET_ALL_DOCTOR_REQUEST' ,
    GET_ALL_DOCTOR_SUCCESS : 'GET_ALL_DOCTOR_SUCCESS' ,
    GET_ALL_DOCTOR_FAILIURE : 'GET_ALL_DOCTOR_FAILIURE',

    GET_DOCTOR_BY_ID_REQUEST : 'GET_DOCTOR_BY_ID_REQUEST' ,
    GET_DOCTOR_BY_ID_SUCCESS : 'GET_DOCTOR_BY_ID_SUCCESS' ,
    GET_DOCTOR_BY_ID_FAILIURE : 'GET_DOCTOR_BY_ID_FAILIURE',


    SEARCH_DOCTOR_REQUEST : 'SEARCH_DOCTOR_REQUEST',
    SEARCH_DOCTOR_SUCCESS : 'SEARCH_DOCTOR_SUCCESS',
    SEARCH_DOCTOR_FAILIURE : 'SEARCH_DOCTOR_FAILIURE',

    SEARCH_DOCTOR_BY_SPECIALIZATION_REQUEST : 'SEARCH_DOCTOR_BY_SPECIALIZATION_REQUEST',
    SEARCH_DOCTOR_BY_SPECIALIZATION_SUCCESS : 'SEARCH_DOCTOR_BY_SPECIALIZATION_SUCCESS',
    SEARCH_DOCTOR_BY_SPECIALIZATION_FAILIURE : 'SEARCH_DOCTOR_BY_SPECIALIZATION_FAILIURE',

    CLEAR_DOCTOR_SEARCH_RESULT : 'CLEAR_DOCTOR_SEARCH_RESULT',

};